import { UserAccount } from "@/redux/slices/userAccount/types";
import {
  GetUserAccountHistoryRawResponse,
  GetUserAccountHistoryResponse,
  GetUserAccountsRawResponse,
  GetUserAccountsResponse,
} from "./types";

export const transformUserAccounts = (res: GetUserAccountsRawResponse) => {
  const {
    _embedded: { accounts },
    page,
    page_count,
    page_size,
    total_items,
  } = res;

  const response: GetUserAccountsResponse = {
    data: {
      items: accounts.map(
        (i) =>
          ({
            id: i.uuid,
            name: i.name,
            status: i.status,
            phone: i.phone,
            email: i.email,
            role: i.role,
          } as UserAccount)
      ),
      page: {
        current: page,
        count: page_count,
        size: page_size,
        total: total_items,
      },
    },
  };

  return response;
};

export const transformUserAccountHistory = (res: GetUserAccountHistoryRawResponse) => {
  const {
    _embedded: { history_logs },
    page,
    page_count,
    page_size,
    total_items,
  } = res;

  const response: GetUserAccountHistoryResponse = {
    data: {
      items: history_logs.map((i) => ({
        dateTime: i.date_time,
        notes: i.notes,
        performedBy: i.performed_by,
      })),
      page: {
        current: page,
        count: page_count,
        size: page_size,
        total: total_items,
      },
    },
  };

  return response;
};
